export const delay = <T>(callback: () => T, time: number): Promise<T> => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(callback()), time);
  });
};
